import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import './assets/global.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import store from './store';
import { resetDevMocks } from './dev/mockApi';

// In development: bypass login with mock user when ?dev=1 or devBypassAuth is set
if (process.env.NODE_ENV === 'development') {
  const params = new URLSearchParams(window.location.search);
  if (params.get('dev') === '1' || localStorage.getItem('devBypassAuth') === 'true') {
    resetDevMocks();
    if (!store.getters['auth/isAuthenticated']) {
      store.commit('auth/ENABLE_DEV_BYPASS');
    }
    if (params.get('dev') === '1' && window.location.pathname === '/') {
      window.history.replaceState({}, '', '/dashboard');
    }
  }
}

const app = createApp(App);
app.use(store);
app.use(router);

// Apply saved theme before mount (avoids flash)
store.dispatch('theme/initTheme');

app.mount('#app');
